module.exports = __webpack_public_path__ + "img/M4_JKKP_07.1df18846.png";